import React from "react";
import NavLinks from "./NavLinks";
import "./styles/TopBar.scss";

function Navigation() {
  return (
    <nav className="navigation">
      <NavLinks />
    </nav>
  );
}

export default Navigation;
